import { render, staticRenderFns } from "./DevHelper.vue?vue&type=template&id=52f44966&"
import script from "./DevHelper.vue?vue&type=script&lang=js&"
export * from "./DevHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports